import { clearFilterParams, useCleanFilterForRequest } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { mergeDeepLeft, pick } from 'ramda'
import React from 'react'

import { formsClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useFormsCounterState = () => React.useContext(Context)
export const useFormsCounter = () => useFormsCounterState()?.formsCount
export const useAllFormsCounter = () => useFormsCounterState()?.all

const QUERY = gql`
  query FormsCount($filter: FormFilter, $fixedFilter: FormFilter) {
    formsCount(filter: $filter)
    all: formsCount(filter: $fixedFilter)
  }
`

const FormsCounterLoader = ({ widget, children }) => {
  const widgetFilter = clearFilterParams(widget.data?.filters || []) || {}
  const ignoreDate = widget?.data?.ignoreDate
  const { date, ...manualFilter } = pick(['date'], useCleanFilterForRequest() || {})
  const insertedAt = !ignoreDate ? date : undefined
  const fullFilter = mergeDeepLeft(widgetFilter, manualFilter)

  const { data, ...state } = useQuery(QUERY, {
    variables: { filter: { ...fullFilter, insertedAt }, fixedFilter: { ...manualFilter, insertedAt } },
    client: formsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FormsCounterLoader
